export default __webpack_public_path__ + "static/media/card-SSLSecure_icon.9ee30948.svg";